//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



export default {
    props: {
        /*
        * Profile - only used for localstorage key
        */
        item: {
            type: Object,
            required: true,
        },
    },
    methods: {
        bkgImageStyle(fimg) {
            if (!fimg) return;
            return {
                'background-image': `url(${fimg})`,
            };
        },
    },
    filters: {
        truncate: function (text, length, suffix = '&hellip;') {
            text = text.replace('[&hellip;]',''); // remove any ellipses added by wp excerpt
            //let closingPIndex = text.lastIndexOf("</p>");
            let truncatedText = text.substring(0, length);
            if (truncatedText == text)
                return text
            else
                return truncatedText + suffix;
        },
        /* Wrap text in p tags if not already formatted */
        paragraphWrap (text) {
            // //let closingPIndex = text.lastIndexOf("</p>");
            if (text.charAt(0) != "<")
                return `<p>${text}</p>`;
            else
                return text
        },
    },
};




// WEBPACK FOOTER //
// ./scripts/vue/ArticleListItem.vue